<template>
  <tooltip interactive :append-to="body" @click.prevent>
    <template #default>
      <div class="modal-icon" @click.prevent.stop="emit('client:call', $event)">
        <div class="flex h-full items-center justify-center">
          <icon-base :icon="IconTelephone" />
        </div>
      </div>
    </template>
    <template #content>
      {{ telephoneNumber }}
    </template>
  </tooltip>
</template>

<script setup lang="ts">
import { ref, type Ref } from "vue";
import { useContacts } from "@/hooks/contacts";
import { useDeals } from "@/hooks/deals";
import IconTelephone from "@/components/icons/IconTelephone.vue";
import type { ApplicationWithContactData } from "@/models/applications";
const emit = defineEmits<{
  "client:call": [MouseEvent];
}>();

const body = ref(document.body);

const { activeDeal } = useDeals();

const { telephoneNumber } = useContacts(
  activeDeal as unknown as Ref<ApplicationWithContactData>
);
</script>
